export enum StreamaxDormantState {
    Awake = "AWAKE",
    Dormant = "DORMANT",
    Unknown = "UNKNOWN"
}